module.exports = __webpack_public_path__ + "img/ic-phone-mobile.222f7124.svg";